"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var segment_1 = require("./segment");
var event_helpers_1 = require("./event-helpers");
exports.trackPageView = event_helpers_1.trackPageView;
exports.trackEvent = event_helpers_1.trackEvent;
exports.setAlias = event_helpers_1.setAlias;
exports.setGroup = event_helpers_1.setGroup;
exports.identifyUser = event_helpers_1.identifyUser;
exports.reset = event_helpers_1.reset;
exports.default = segment_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@redux-beacon/segment/dist/index.js
// module id = 1569
// module chunks = 49